import type { AxiosResponse } from 'axios';
import api, { succeedOn404 } from './api';
import type {
  AccessRequestCreateType,
  AccessRequestReadType,
  AccessRequestUpdateType,
} from 'bc-model';

async function createAccessRequest(
  payload: AccessRequestCreateType
): Promise<AxiosResponse<AccessRequestReadType>> {
  return api.post(`/api/accessRequests`, payload);
}

async function retrieveAccessRequests(): Promise<
  AxiosResponse<{ [id: number]: AccessRequestReadType }>
> {
  return api.get(`/api/accessRequests`, succeedOn404);
}

async function updateAccessRequest(
  payload: AccessRequestUpdateType
): Promise<AxiosResponse<AccessRequestReadType>> {
  return api.post(`/api/accessRequests/${encodeURIComponent(payload.id)}`, payload);
}

export { createAccessRequest, retrieveAccessRequests, updateAccessRequest };
